import React, { useState, useRef, useMemo, useEffect } from 'react';
import JoditEditor from 'jodit-react';
import { useParams } from 'react-router-dom';

const PlacementJoditEditor = ({ placeholder, subTitle, editorContent, onContentChange }) => {
  const {id} = useParams();
	const editor = useRef(null);
	const [content, setContent] = useState(editorContent);


	const insertDefaultTable = (subTitle) => {
		let tableHtml = '';
		
		if (subTitle === "placementActivities") {
			tableHtml=`<table style="border-collapse:collapse;width: 100%;"><tbody>
<tr>
	<td style="width: 20%;">S.No</td>
	<td style="width: 20%;">Programme</td>
	<td style="width: 20%;">Opted</td>
	<td style="width: 20%;">Placed</td>
	<td style="width: 20%;">% Placed</td></tr>
<tr>
	<td style="width: 20%;">1</td>
	<td style="width: 20%;"></td>
	<td style="width: 20%;"></td>
	<td style="width: 20%;"></td>
	<td style="width: 20%;"></td></tr></tbody></table>
	
	<table style="border-collapse:collapse;width: 100%;"><tbody>
<tr>
	<td style="width: 25%;">S.No</td>
	<td style="width: 25%;">Company</td>
	<td style="width: 25%;">Package Offered(UG)</td>
	<td style="width: 25%;">Package Offered(PG)</td></tr>
<tr>
	<td style="width: 25%;">1</td>
	<td style="width: 25%;"><br></td>
	<td style="width: 25%;"><br></td>
	<td style="width: 25%;"><br></td></tr></tbody></table>`
	// 		tableHtml = `
	// 			<table style="margin: auto; border: 3px solid black; border-collapse: collapse;" cellpadding="5" cellspacing="0">
    //     <thead>
    //       <tr>
    //         <th style="border: 3px solid black;">S.No</th>
    //         <th style="border: 3px solid black;">Programme</th>
    //         <th style="border: 3px solid black;">Opted</th>
    //         <th style="border: 3px solid black;">Placed</th>
    //         <th style="border: 3px solid black;">% Placed</th>
    //       </tr>
    //     </thead>
    //     <tbody>
    //       <tr>
	// 				<td style="border: 3px solid black;" contenteditable="true">1</td>
	// 				<td style="border: 3px solid black;" contenteditable="true" data-placeholder="Type here..."></td>
	// 				<td style="border: 3px solid black;" contenteditable="true" data-placeholder="Type here..."></td>
	// 				<td style="border: 3px solid black;" contenteditable="true" data-placeholder="Type here..."></td>
	// 				<td style="border: 3px solid black;" contenteditable="true" data-placeholder="Type here..."></td>

    //       </tr>
    //     </tbody>
	// 		<style>
    //             td[contenteditable="true"]:empty:before {
    //                 content: attr(data-placeholder);
    //                 color: #ccc; 
    //             }
                
    //             td[contenteditable="true"]:focus:before {
    //                 content: '';
    //             }
    //         </style>
    //   </table><br><br>
    //   <table style="margin: auto; border: 3px solid black; border-collapse: collapse;" cellpadding="5" cellspacing="0">
    //     <thead>
    //       <tr>
    //         <th style="border: 3px solid black;">S.No</th>
    //         <th style="border: 3px solid black;">Company</th>
    //         <th style="border: 3px solid black;">Package offered(UG)</th>
    //         <th style="border: 3px solid black;">Package Offered(PG)</th>
    //       </tr>
    //     </thead>
    //     <tbody>
    //       <tr>
	// 				<td style="border: 3px solid black;" contenteditable="true">1</td>
	// 				<td style="border: 3px solid black;" contenteditable="true" data-placeholder="Type here..."></td>
	// 				<td style="border: 3px solid black;" contenteditable="true" data-placeholder="Type here..."></td>
	// 				<td style="border: 3px solid black;" contenteditable="true" data-placeholder="Type here..."></td>
    //       </tr>
    //     </tbody>
	// 		<style>
    //             td[contenteditable="true"]:empty:before {
    //                 content: attr(data-placeholder);
    //                 color: #ccc; 
    //             }
                
    //             td[contenteditable="true"]:focus:before {
    //                 content: '';
    //             }
    //         </style>
    //   </table>`;
		} 
		
		setContent(tableHtml.trim());
	};

	const insertImage = (resp) => {
		const imageUrl = `${process.env.REACT_APP_BASE_URL}/api/object/${resp.id}`;
		const imgHtml = `<img src="${imageUrl}" alt="Image" style="max-width: 100%; height: auto;" />`;
		const currentContent = editor.current?.value || content;  
		const updatedContent = currentContent + imgHtml;
		setContent(updatedContent);
		onContentChange(updatedContent);
	};

	// Memoized configuration for JoditEditor
	const config = useMemo(() => ({
		readonly: false,
		placeholder: placeholder || '',
		toolbar: {
			buttons: [
				'bold',
				'italic',
				'underline',
				'image', // Include the image button
				'|', // Divider
				'source',
			],
		},
		uploader: {
			insertImageAsBase64URI: false,
			url: `${process.env.REACT_APP_BASE_URL}/api/report/${id}/upload`,
			headers: {
				Authorization: `Bearer ${localStorage.getItem("jwt")}`
			},
			method: 'POST',
			prepareData: (formData) => {
				const files = formData.getAll('files[0]'); 
				formData.delete('files[0]'); 
			
				files.forEach((file) => {
					formData.append('file', file); 
				});
				return formData;
			}
			,
			isSuccess: (resp) => {
				return resp;
			},
			process: (resp) => {
				console.log('File uploaded successfully:', resp);
				insertImage(resp);
				return {}; 
			},
			error: (e) => {
				console.error('Upload error', e);
			}
		},
		events: {
			beforeImage: function(current) {
				return false; 
			},
			'errorMessage': function(message) {
				console.error(message);
			}
		}
	}), [placeholder, id]);

	useEffect(() => {
		if (!editorContent) {
			insertDefaultTable(subTitle);
		 } else{
			setContent(editorContent);
		 }
	}, [subTitle]);

	const handleContentChange = (newContent) => {
		setContent(newContent);
		onContentChange(newContent);
	  };

	return (
		<JoditEditor
			ref={editor}
			value={content}
			config={config}
			tabIndex={1}
			onBlur={(newContent) => handleContentChange(newContent)}
			onChange={(newContent) => {}}
		/>
	);
};

export default PlacementJoditEditor;
